const chat = require('../../../../../components/chat/chat')
const chatQuickview = require('../../../../../components/chat/chat-container')
const chatActions = require('../../../../../components/chat/chat-actions')
const chatHandler = require('../../../../../components/chat/chat-handler')
const handler = require('./purchase-fullcont-handler')

export function start(detail) {
    if (obj[detail.act]) {
        obj[detail.act].start(detail)
    }
}

const obj = {
    load:       { start: (detail) => { load(detail)         } },
    submit:     { start: (detail) => { submit(detail)       } },
    typing:     { start: (detail) => { typing(detail)       } },
    beforeChat: { start: (detail) => { beforeChat(detail)   } },
}

function load(detail) {

    const fullcontActivo = document.getElementById(`${detail.dest}-fullcont`)
    const recordId = fullcontActivo.getAttribute('data-dbid')

    if (recordId) {
        chat.start(
            {
                "dest": "chat",
                "act": "quickview",
                "actQuickview": "show",
                "type": "purchase",
                "entity": "purchase",
                "question": detail.question ?? "",
                "recordId": recordId,
                "ev": detail.ev
            }
        )

        const msj = handler.getChatsFc();
        chat.start({
            "dest": "chat",
            "act": "load",
            "chats": msj
        })
    }

}

function beforeChat(detail) {

    const htmlFc = handler.getDataFc()

    const dataToSend = handler.getValuesForChat(detail, htmlFc)
    if (dataToSend) {
        chat.start(
            {
                "dest": "chat",
                "act": "quickview",
                "actQuickview": "show",
                "type": "purchaseBefore",
                "entity": "purchase",
                "data": dataToSend,
                "question": detail.question ?? "",
                "ev": detail.ev
            }
        )
    }
}

function typing(detail) {
    chatHandler.typing(detail)
}